<div
  class="medium-content color-600"
  data-test="medium-content-container"
  *ngIf="props$ | async as props"
>
  <div class="image me-3" *ngIf="thumbnail">
    <flo-image-thumbnail
      [imageUrl]="props?.asset?.url"
      [imageSize]="660"
      [altText]="props.title || title"
      [duration]="props.duration"
    ></flo-image-thumbnail>
  </div>
  <div class="content-feed" data-test="banner-content">
    <h4
      class="headline font-family-bold apply-text-hover primary-color-text-hover m-0 mb-1 text-line-clamp-2 title-overflow"
      data-test="title"
    >
      <i
        *ngIf="props?.premium"
        floSvg="badge_pro_dark"
        class="me-1 align-text-top" data-test="article-pro"
      ></i>
      <span class="apply-text-hover">{{ title }}</span>
    </h4>

    <div class="pb-0 pb-md-2 mb-0 mb-md-1 date-footnote" data-test="footnote">
      <ng-container *ngIf="props.showPublishDate">
        <ng-container *ngIf="props.type === 'ranking'; else standardView">
          <p
            class="subhead m-0"
            data-test="publish-date"
          >Last Updated on {{ props.modifiedDate | floDateYear }}
          </p>
        </ng-container>
        <ng-template #standardView>
          <p
            class="subhead m-0"
            data-test="publish-date"
          >{{ props.dateToRender | floDateYear }}</p>
        </ng-template>


      </ng-container>

      <p
        *ngIf="props.showEventDate"
        class="subhead m-0"
        data-test="event-date"
        >{{ props.start_date | floDateYear: props?.end_date }}</p
      >
    </div>
    <div
      *ngIf="props.showEventDescription"
    >
      <div
        data-test="event-description"
        class="event-description description-overflow dynamic-html-line-clamp-2 text-line-clamp-2 subhead"
        [innerHtml]="props.preview_text | floSanitizeHtml"
      ></div>
    </div>
    <p
      *ngIf="props.showVideoDescription"
      class="description-overflow text-line-clamp-2 subhead"
      data-test="video-description"
      >{{ props.description_plain }}</p
    >
    <p
      *ngIf="props.isBanner && props.description"
      class="description-overflow text-line-clamp-2 subhead"
      data-test="banner-description"
      >{{ props.description }}</p
    >
  </div>
</div>
